import { FormControl, FormGroup } from '@angular/forms';

export class DailyRegisterExtension {
  pctTerminationDT?: Date;
  luisStatusEnglish: string;
  luisStatusFrench: string;

  /**
  * Override the default validation controls to set
  * @param form
  */
  static overrideDefaultForm(form: FormGroup) {
    form.addControl('pctTerminationDT', new FormControl({ value: null, disabled: form.disabled }));
    form.addControl('luisStatusEnglish', new FormControl({ value: null, disabled: form.disabled }));
    form.addControl('luisStatusFrench', new FormControl({ value: null, disabled: form.disabled }));
  }
}
